import { createSelector } from "reselect";
import get from "lodash.get";

const authEntitySelector = (state: TReduxState) => state?.root.entities?.auth;

export const getLoggedInUser = createSelector(authEntitySelector, (appData) =>
  get(appData, "data", null)
);

export const getPasswordRecoverEmail = createSelector(authEntitySelector, (token) => token.givenEmailForPasswordRecovery);